import { Link } from "@inertiajs/react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import Main from "../../../components/layout/Main";
import MetaData from "../../../components/MetaData";
import { formatDate } from "../../../lib/format";
import { EventAdminIndex } from "../../../types/Event";

const SEO_TITLE = "Admin";

const Index = ({ events }: { events: EventAdminIndex[] }) => {
  return (
    <Main>
      <MetaData title={SEO_TITLE} />
      <TableContainer>
        <Table aria-label="simple table" sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: "bold" } }}>
              <TableCell>Naam</TableCell>
              <TableCell>Datum</TableCell>
              <TableCell>Openstaand</TableCell>
              <TableCell>Geaccepteerd</TableCell>
              <TableCell>Gepubliceerd</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.id}>
                <TableCell>
                  <Link href={`/admin/events/${event.id}`}>{event.name}</Link>
                </TableCell>
                <TableCell>{formatDate(event.startsAt)}</TableCell>
                <TableCell>{event.pendingCount}</TableCell>
                <TableCell>{event.acceptedCount}</TableCell>
                <TableCell>{event.published.toString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Main>
  );
};

export default Index;
